<script lang="ts">
    import type { SocialProof } from '@shared/types/types';

    /*                                                                   */
    interface Props {
        socialProof: SocialProof;
        /*                                                                                                    */
        placement?: 'image' | 'content';
    }

    let { socialProof, placement = 'image' }: Props = $props();
</script>

{#snippet proof(text: string)}
    <oc-tag-v1 variant="info-primary" size={'50'}>
        {text}
    </oc-tag-v1>
{/snippet}

{#if socialProof.popular || socialProof.shortage}
    <div class="reptile-social-proof-badges" class:reptile-social-proof-badges--content={placement === 'content'}>
        {#if socialProof.popular}
            {@render proof('Sehr beliebt')}
        {/if}
        {#if socialProof.shortage}
            {@render proof('Fast ausverkauft')}
        {/if}
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-social-proof-badges {
        /**
 */
        position: absolute;
        bottom: 0;
        left: 0;

        display: flex;
        flex-flow: row wrap;
        gap: tokens.$oc-semantic-spacing-absolute-25;
        align-items: flex-end;

        margin-right: tokens.$oc-semantic-spacing-absolute-75;
        margin-bottom: tokens.$oc-semantic-spacing-absolute-50;
        margin-left: tokens.$oc-semantic-spacing-absolute-75;

        &--content {
            position: static;
            margin: 0;
        }
    }
</style>
